import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import EmployeePointsBalance from './EmployeePointsBalance'

export default function Employees() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/employees/points" component={EmployeePointsBalance} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}